// types
import { type ModuleType as Preference } from "./_definitions"
import { type State } from "../../types"

export const preferenceSelector = (state: State): Preference => state.preference
